import React from 'react';
import Select from 'react-select';
import Toaster from 'toastr';
import { connect } from 'react-redux';
import { Permissioned } from 'react-permissions';
import Messages from '../../../configurations/messages';
import Permissions from '../../../configurations/permissions';
import Util from '../../../util/util';
import ArbiterApi from '../../../api/ArbiterApi';
import Modal from '../../common/modal';
import FloatInput from '../../common/floatInput';
import CButton from '../../common/connectedButton';

class DisputeTimelinesModal extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isNew: props.isNew,
            isView: !props.isNew,
            isDelete: false,
            disputeTimeline: props.isNew ? {} : props.disputeTimeline,
            disputeRegions: [],
            disputeCategories: [],
            disputeStatuses: [],
            disputeRegion: null,
            disputeCategory: null,
            disputeStatus: null,
            title: props.isNew ? "New Dispute Timeline" : `Dispute Timeline`,
            updating: false,
            touchedForm: false,
            disputeRegionValidity: -1,
            disputeStatusValidity: -1,
            disputeCategoryValidity: -1,
            validTimeValidity: -1

        };

        this.modalStyle = {
            ovelay: {},
            content: {
                top: "80px",
                left: "250px",
                right: "250px",
                bottom: "100px",
                zIndex: "1000"
            }
        }
        this.onTextInputChange = this.onTextInputChange.bind(this);
        this.onDisputeRegionChange = this.onDisputeRegionChange.bind(this);
        this.onDisputeCategoryChange = this.onDisputeCategoryChange.bind(this);
        this.onDisputeStatusChange = this.onDisputeStatusChange.bind(this);
    }

    onTextInputChange(evt) {

        let disputeTimeline = Object.assign({}, this.state.disputeTimeline);
        disputeTimeline[evt.target.id] = evt.target.value || null;

        let stateUpdate = {
            disputeTimeline,
            touchedForm: true,
        }
        stateUpdate[`${evt.target.id}Validity`] = evt ? 1 : 0;

        this.setState(stateUpdate);
    }

    onDisputeRegionChange(evt) {
        let disputeTimeline = Object.assign({}, this.state.disputeTimeline);
        disputeTimeline.disputeRegion = evt ? evt.value : null;

        this.setState({
            disputeTimeline,
            disputeRegion: evt,
            touchedForm: true,
            disputeRegionValidity: evt ? 1 : 0

        });
    }

    onDisputeCategoryChange(evt) {
        let disputeTimeline = Object.assign({}, this.state.disputeTimeline);
        disputeTimeline.disputeCategory = evt ? evt.value : null;

        this.setState({
            disputeTimeline,
            disputeCategory: evt,
            disputeStatuses: evt ? evt.statuses : [],
            disputeStatus: null,
            touchedForm: true,
            disputeCategoryValidity: evt ? 1 : 0

        });
    }

    onDisputeStatusChange(evt) {
        let disputeTimeline = Object.assign({}, this.state.disputeTimeline);
        disputeTimeline.disputeStatus = evt ? evt.value : null;

        this.setState({
            disputeTimeline,
            disputeStatus: evt,
            touchedForm: true,
            disputeStatusValidity: evt ? 1 : 0

        });
    }


    componentDidMount() {

        //Get Dispute Regions
        ArbiterApi.getDisputeRegions()
            .then(response => {

                let disputeRegions = response.data.content.map(obj => {

                    obj.label = obj.name;
                    obj.value = obj.name;
                    return obj;
                });

                this.setState({ disputeRegions });
            })
            .catch(error => {
                Util.errorMessageToast(Toaster, error.data, [`${Messages.ERROR_DISPUTE_REGION}`, '']);
                console.log(error);
            })

        //Get Dispute Categories
        ArbiterApi.getDisputeCategories()
            .then(response => {
                let disputeStatuses = [];
                let disputeCategories = response.data.map(obj => {

                    obj.label = obj.category;
                    obj.value = obj.category;
                    obj.statuses = obj.statuses.map(status => {
                        return {
                            label: status,
                            value: status,
                        }
                    }); 
                    return obj;
                });
                
                if(this.state.disputeTimeline.disputeCategory){
                    disputeCategories.forEach(category => {
                        if(category.value === this.state.disputeTimeline.disputeCategory ){
                            disputeStatuses = category.statuses;
                        }
                    })
                }

                this.setState({ disputeCategories, disputeStatuses });
            })
            .catch(error => {
                Util.errorMessageToast(Toaster, error.data, [`${Messages.ERROR_DISPUTE_CATEGORIES}`, '']);
                console.log(error);
            })




    }
    handleAction(evt) {
        this.setState({ updating: true });

        const disputeTimeline = this.state.disputeTimeline;
        const isNew = this.state.isNew;
        let promise = this.state.isNew ? ArbiterApi.createDisputeTimeline(disputeTimeline) : ArbiterApi.updateDisputeTimeline(disputeTimeline.id, disputeTimeline)
        promise.then((response) => {
            Toaster.success(`Dispute Timeline  successfully  ${isNew ? 'created' : 'updated'}`);
            this.setState({ updating: false });
            this.props.onRequestClose(evt, true);
        })
            .catch((error) => {
                Util.errorMessageToast(Toaster,error.data,[`${error.data ? error.data.description : error.statusText}`,`${Messages.ERROR_DISPUTE_TIMELINES_UPDATE} `]);
                this.setState({ updating: false });
            })
    }

    handleDeleteAction(evt) {
        this.setState({ updating: true });
        const disputeTimeline = this.state.disputeTimeline;
        ArbiterApi.deleteDisputeTimeline(disputeTimeline.id)
            .then((response) => {
                Toaster.success(Messages.SUCCESS_DISPUTE_TIMELINE_DELETE);
                this.setState({ updating: false });
                this.props.onRequestClose(evt, true);
            })
            .catch((error) => {
                console.log(error);
                Util.errorMessageToast(Toaster, error.data, [`${Messages.ERROR_DISPUTE_TIMELINES_DELETE}`, '']);
                this.setState({ updating: false });
            });
    }


    render() {
        const isNew = this.state.isNew;
        const isView = this.state.isView;
        const isDelete = this.state.isDelete;
        return (
            <Modal title={this.state.title} isOpen={this.props.isOpen} style={this.modalStyle} onRequestClose={this.props.onRequestClose}>
                {isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label>Dispute Region:</label>
                                        <label>{this.state.disputeTimeline.disputeRegion}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Dispute Category:</label>
                                        <label>{this.state.disputeTimeline.disputeCategory}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Dispute Status:</label>
                                        <label>{this.state.disputeTimeline.disputeStatus}</label>
                                    </div>

                                    <div className="form-div">
                                        <label>Valid Time :</label>
                                        <label>{this.state.disputeTimeline.validTime}</label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                }
                {!isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label className="required">Dispute Region</label>
                                        <Select
                                            id="disputeRegion"
                                            value={this.state.disputeTimeline.disputeRegion}
                                            options={this.state.disputeRegions}
                                            onChange={this.onDisputeRegionChange}
                                            placeholder="Select Dispute Region"
                                        />
                                    </div>

                                    <div className="form-div">
                                        <label className="required">Dispute Category</label>
                                        <Select
                                            id="disputeCategory"
                                            value={this.state.disputeTimeline.disputeCategory}
                                            options={this.state.disputeCategories}
                                            onChange={this.onDisputeCategoryChange}
                                            placeholder="Select Dispute Category"
                                        />
                                    </div>
                                    <div className="form-div">
                                        <label className="required">Dispute Status</label>
                                        <Select
                                            id="disputeStatus"
                                            value={this.state.disputeTimeline.disputeStatus}
                                            options={this.state.disputeStatuses}
                                            onChange={this.onDisputeStatusChange}
                                            placeholder="Select Dispute Status"
                                        />
                                    </div>
                                    <div className="form-div">
                                        <label className="required">Validity Time (in hours)</label>
                                        <FloatInput
                                            id="validTime"
                                            value={this.state.disputeTimeline.validTime}
                                            onChange={this.onTextInputChange}
                                            placeholder="Enter Validity Time"
                                            maxLength="5"
                                            min="1"
                                            type="number"
                                            showError={this.state.validTimeValidity === 0} errorMessage={`${Messages.INVALID_CODE}`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                }
                {!isDelete &&
                    <div className="mod-footer">

                        <div className="mod-footer-buttons">
                            {isView &&
                                <CButton
                                    onClick={(evt) => { this.setState({ isView: false }) }}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.UPDATE_DISPUTE_TIMELINE]}>EDIT</CButton>
                            }
                            {isView &&
                                <CButton
                                    onClick={(evt) => { this.setState({ isDelete: true }) }}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.DELETE_DISPUTE_TIMELINE]}>DELETE</CButton>

                            }

                            {!isView && isNew &&
                                <CButton
                                    onClick={(evt) => { this.handleAction(evt); }}
                                    disabled={this.state.updating || !this.formValid()}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.CREATE_DISPUTE_TIMELINE]}>CREATE</CButton>

                            }
                            {!isView && !isNew &&
                                <CButton
                                    onClick={(evt) => { this.handleAction(evt); }}
                                    disabled={this.state.updating || !this.formValid()}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.UPDATE_DISPUTE_TIMELINE]}>UPDATE</CButton>

                            }

                            <button onClick={(evt) => { this.props.onRequestClose(evt); }} disabled={this.state.updating} className="btn btn-danger">CLOSE</button>

                        </div>
                    </div>
                }
                {isDelete &&
                    <div className="mod-footer">
                        <div className="action-warning">
                            {Messages.ACTION_WARNING}  ?
                                </div>
                        <div className="mod-footer-buttons">
                            <button onClick={(evt) => { this.setState({ isDelete: false }) }} disabled={this.state.updating} className="btn btn-danger">NO</button>
                            <button onClick={(evt) => { this.handleDeleteAction(evt) }} disabled={this.state.updating} className="btn btn-primary">YES</button>

                        </div>
                    </div>
                }
            </Modal>
        )
    }

    formValid() {
        if (this.state.isNew)
            //Each field must have an exact validity i.e. validity must exact equal '1'
            return this.state.touchedForm && this.state.disputeRegionValidity === 1 && this.state.disputeCategoryValidity === 1 && this.state.disputeStatusValidity === 1 && this.state.validTimeValidity === 1;
        //all fields must be valid i.e validity must be 1 or -1 (for untouched fields)
        return this.state.touchedForm && this.state.disputeRegionValidity && this.state.disputeCategoryValidity && this.state.disputeStatusValidity && this.state.validTimeValidity;
    }

}

export default connect(Util.defaultMapStateToProps)(Permissioned(DisputeTimelinesModal, [Permissions.VIEW_DISPUTE_TIMELINE]));


// WEBPACK FOOTER //
// ./src/components/admin/disputeTimelines/disputeTimelinesModal.js